import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { MCommonListModalRequest } from 'src/app/utils/utils.service';
import { WsCheckoutService } from 'src/app/ws/wsCheckout/ws-checkout.service';

@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.scss']
})
export class OfferListComponent {
  offersDiscountCatelogue: any;
  discountCatelogueList: any;
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest();
  constructor(private wsCheckoutService: WsCheckoutService, private router: Router){

  }

  ngOnInit(){
    this.getAllDiscountCatelogue()
  }

  async getAllDiscountCatelogue(){
    this.mCommonListModalRequest.take = 1000;
    this.offersDiscountCatelogue = [];
    const getAllDiscount = this.wsCheckoutService.getAllDiscountCatelogue(this.mCommonListModalRequest)
    await lastValueFrom(getAllDiscount).then(async response => {
      if (response && response.statusCode == 200) {
        this.discountCatelogueList = response['data'];
        await response['data'].forEach((discountCateloge:any) => {
          if(discountCateloge.type == 'offers'){
            this.offersDiscountCatelogue.push(discountCateloge);
          }
        })
      }
    });
  }

  redirectToShopAll(url:any){
    this.router.navigate([url])
  }

  showImage(image:any){ 
    return image;
  }
}
